import { Component } from "preact";
import '../style/action-btn.css';
import { ConfigContext } from '../contexts/config';

export default class ActionBtn extends Component {
    onClick() {
        this.props.onAction();
    }

    render() {
        const wrapperStyle = {
            width: this.props.width + 'px',
            height: this.props.height + 'px',
            maxHeight: '100%',
            maxWidth: '100%',
        };

        if (!this.props.show) {
            wrapperStyle.display = 'none';
        }

        return (
            <ConfigContext.Consumer>
                {config => (
                    <div style={wrapperStyle}>
                        <div onClick={this.onClick.bind(this)} className={'action-btn'}>
                            { config.getTranslations().actionBtnLabel }
                        </div>
                    </div>
                )}
            </ConfigContext.Consumer>
        )
    }
}